import type { FC, ReactNode } from "react";

import { COLOR_TEXT } from "./colorTokens";

type CountBadgeVariant = "default" | "success" | "warning" | "error";

interface CountBadgeProps {
  children: ReactNode;
  className?: string;
  variant?: CountBadgeVariant;
}

const variantClasses: Record<CountBadgeVariant, string> = {
  default: "text-gray-400 dark:text-white/50",
  error: COLOR_TEXT.rose,
  success: COLOR_TEXT.emerald,
  warning: COLOR_TEXT.amber,
};

/**
 * Small uppercase counter badge for displaying counts in panel headers.
 */
export const CountBadge: FC<CountBadgeProps> = ({
  children,
  className = "",
  variant = "default",
}) => (
  <span
    className={`text-xs uppercase tracking-[0.3em] ${variantClasses[variant]} ${className}`}
  >
    {children}
  </span>
);
